import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import { ContractStepModel } from '../../../../models/contract.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { TFormState } from '../../../../models/forms.model';
import { MatDialog } from '@angular/material/dialog';
import { TaskDetailComponent } from '../../../../components/task-detail/task-detail.component';
import { ContractContextMenuService } from '../../services/contract-context-menu.service';
import { AppContractStepTargetSelectComponent } from '../contract-step-target-select/contract-step-target-select.component';
import { IContractDataModel } from '../../models/contract-internal-models';
import { ContractDataService } from '../../services/contract-data.service';
import { catchError, EMPTY, filter, Subscription, switchMap, tap } from 'rxjs';
import { ContractAvatarsService } from '../../services/contract-avatar.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../../services/notify/alert.service';
import { ContractsService } from '../../../../services/api/contracts.service';
import { DialogsMTService } from '../../../../services/modal/dialogs-mt.service';
import { ContractFormService } from '../../services/contract-form.service';


@Component({
    selector: 'app-contract-step-task',
    templateUrl: './contract-step-task.component.html',
    styleUrl: './contract-step-task.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
})
export class AppContractStepTaskComponent {
    private subs:Subscription = new Subscription()
    @Input() public contractStep: ContractStepModel|null = null;
    @Input() public contractData: IContractDataModel|null = null;
    public formState:TFormState = 'Default'
    public stepsStylingMap = STEPS_STYLING_MAP
    public notSingedMembers:string[]|undefined = []
    public singedMembers:string[]|undefined = []
    public signState:{label:string,disabled:boolean, stepSignedByUser:boolean}|null = null
    constructor(
      private cds:ChangeDetectorRef,
      private alertService:AlertService,
      private translateService:TranslateService,
      private dialog:MatDialog,
      private contractsService:ContractsService,
      private contextMenuService:ContractContextMenuService,
      private contractDataService:ContractDataService,
      public contractAvatarsService:ContractAvatarsService,
      public dialogsMTService:DialogsMTService,
      public contractFormService:ContractFormService
    ) { }
    ngOnDestroy(): void {
      this.subs.unsubscribe()
    }
    ngOnInit(): void {
      this.setSingingState()
      this.subs.add(this.contractDataService.subStepDataChanged.asObservable().subscribe(()=>this.cds.detectChanges()))
    }
    ngOnChanges(): void {
      this.setSingingState()
    }
    viewTaskInDialog() {
      if (this.contractStep?.target_key) {
        this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
          let dialogRef = this.dialog.open(TaskDetailComponent, {
            panelClass: 'contract-task-step-padding-modalbox',
            height: '90%',
            maxHeight: '100%',
            width: '80%',
            maxWidth: '100vw'
          })
          dialogRef.componentInstance.taskAlias = this.contractStep?.target_key
        })
      }
    }
    deleteStep() {
      this.contextMenuService.dispatchDeleteEvent(null,'roadMapStep',this.contractStep,this.contractData.contract.contract.guid)
    }
    addTask() {
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{  
        let stepSelectModal = this.dialog.open(AppContractStepTargetSelectComponent,{
                minWidth: '80vw',
              maxHeight: '97vh',
              panelClass: 'project-select-padding-modalbox'
        })
        stepSelectModal.componentInstance.roadmap = this.contractData?.contract?.roadmap_active.steps!
        stepSelectModal.componentInstance.step = this.contractStep! 
        stepSelectModal.componentInstance.dialogToClose = stepSelectModal
      })
    }
    setSingingState() {
      let allSigners = this.contractData?.allSignatoriesInContract.map(el=>el.member.guid)
      this.singedMembers = this.contractStep?.members_signed_step?.map(el=>el.member_guid)
      this.notSingedMembers = this.singedMembers? allSigners?.filter(el=>this.singedMembers?.includes(el)===false) : allSigners
      let enabled = this.contractData?.rights.isCurrentMemberSigner &&
        this.contractData?.contract?.contract.status === 'verified' &&
        !this.contractStep?.completed_at &&
        this.contractData?.allSignatoriesInContract.length !== this.contractStep?.members_signed_step?.length &&
        this.contractStep?.target && this.contractStep?.target.is_verified;
      let isCurrentMemberSignedTask = this.contractStep?.members_signed_step?.map(el=>el.member_guid)?.includes(this.contractDataService?.currentMember?.guid||'')||false;
      let label =  this.translateService.instant(isCurrentMemberSignedTask? 'CONTRACTS.CARD.RECALL' : 'CONTRACTS.CARD.APPROVE') 
      this.signState ={
        label:label,
        disabled:!enabled ,
        stepSignedByUser:isCurrentMemberSignedTask
      }
    }
    approveStep() {
      this.contractFormService.checkInterDomainRedirect(this.contractData.contract.contract).subscribe(()=>{
        let userGuid = this.contractDataService.currentMember?.guid
        this.formState = 'Submitting'
        let data = {
          PIN_code:'',
          contract_guid:this.contractData?.contract?.contract.guid!
        }
        let requestToSingOnOffTask = this.signState?.stepSignedByUser? 
          this.contractsService.terminateTask(this.contractStep?.target_key!,this.contractStep?.target_type!,data)
          :this.contractsService.signTask(this.contractStep?.target_key!,this.contractStep?.target_type!,data);
        let confirmMessage = this.signState?.stepSignedByUser?  
          this.translateService.instant('MODALS.HEADERS.RECALL_TASK') : this.translateService.instant('MODALS.HEADERS.SIGN_TASK');
        let pinMessage = this.translateService.instant(this.signState?.stepSignedByUser?  'MODALS.HEADERS.RECALL_TASK' :'MODALS.HEADERS.SIGN_TASK');

        this.dialogsMTService.confirmDialog({actionHeader: 'CONFIRM.HEADERS.ATTENTION',actionBody: confirmMessage})
        .pipe(
          tap(res=>res.isConfirmed !== true ?this.changeState('Default') :null),
          filter(res => res.isConfirmed),
          switchMap(()=>this.dialogsMTService.openPinDialog(!this.signState?.stepSignedByUser,pinMessage)),
          tap(res=>res.pin == null? this.changeState('Default') :null),
          filter(res => res.pin !== null),
          tap(res=>data.PIN_code = res.pin.toString()),
          switchMap(()=>requestToSingOnOffTask),
          (catchError(e=>{
            this.alertService.setAlert(e.message,'blue')
            this.changeState('Default')
            return EMPTY
          })))
        .subscribe(data=>{
          let userAvatar = this.contractStep?.membersAvatarsToShow?.find(el=>el.guid === userGuid)
          userAvatar? userAvatar.state = !userAvatar.state : null
          if (this.signState?.stepSignedByUser) {
            let ind = this.contractStep?.members_signed_step?.findIndex(el=>el.member_guid === userGuid)
            ind !== undefined? this.contractStep?.members_signed_step?.splice(ind,1) : null;
          } else {
            this.contractStep?.members_signed_step?.push({created_at:'', member_guid:userGuid!})
          }
          this.setSingingState() 
          this.contractDataService.subStepDataChanged.next({
            step:this.contractStep!,
            stepName:this.contractStep!.name||this.contractStep!.auto_name||''
          })
          this.alertService.setAlert(data.message,'nd_color')
          this.changeState('Default')
        })
      })
    }
    changeState(state:TFormState) {
      this.formState = state
      this.cds.detectChanges()
    }
}
